import request from '@/utils/request'


// 分页查询拆装列表
export function paginationCompany(query = {}, pagination) {
  query.pageNum = pagination.pageNum;
  query.pageSize = pagination.pageSize;
  return request({
    url: `/system/company/list`,
    method: 'get',
    params: query
  })
}

// 查询账套列表
export function listCompany(query) {
  return request({
    url: '/system/company/list',
    method: 'get',
    params: query
  })
}

// 查询账套列表 不分页
export function listAllCompany(query) {
  return request({
    url: '/system/company/listAll',
    method: 'get',
    params: query
  })
}

// 查询账套详细
export function getCompany(cpid) {
  return request({
    url: '/system/company/' + cpid,
    method: 'get'
  })
}

// 新增账套
export function addCompany(data) {
  return request({
    url: '/system/company',
    method: 'post',
    data: data
  })
}

// 修改账套
export function updateCompany(data) {
  return request({
    url: '/system/company',
    method: 'put',
    data: data
  })
}

// 删除账套
export function delCompany(cpid) {
  return request({
    url: '/system/company/' + cpid,
    method: 'delete'
  })
}


// 查询过期应用列表
export function expireAppList(data) {
  return request({
    url: '/system/company/expireAppList',
    method: 'post',
    data: data
  })
}

// 更新公司部分信息（只允许修改公司名称、报表开始时间、结束时间、logo）
export function updateCompanyInfo(data) {
  return request({
    url: '/system/company/updateCompanyInfo',
    method: 'put',
    data: data
  })
}
